// Two-Phase Leitner System Constants

// ============================================================================
// Phase 1: Ordered Acquisition
// ============================================================================

// Focus set size (was 8, now 12)
export const FOCUS_SET_SIZE = 12;

// Box promotion criteria
export const STABLE_CORRECT_COUNT = 3;    // 3 correct recalls to be stable
export const STABLE_SESSION_COUNT = 2;    // Must span at least 2 sessions

// Graduation settings
export const GRADUATION_THRESHOLD = 10;   // Retire 10 cards when they reach Box 3
export const GRADUATION_KEEP_SHAKY = 2;   // Keep 2 shaky cards after graduation

// Total problems to complete Phase 1
export const PHASE_1_TOTAL_PROBLEMS = 150;

// Box values for special states
export const BOX_GRADUATED = 99;          // Graduated cards in Phase 1

// ============================================================================
// Phase 2: Mixed Retention (Leitner intervals)
// ============================================================================

// Intervals in days for each box level
export const LEITNER_INTERVALS: Record<number, number> = {
  1: 1,   // Box 1: review daily
  2: 2,   // Box 2: every 2 days
  3: 4,   // Box 3: every 4 days
  4: 7,   // Box 4: weekly
  5: 12,  // Box 5: every 12 days
};

// Maximum box level in Phase 2
export const MAX_BOX_PHASE_2 = 5;

// Session size for Phase 2
export const PHASE_2_SESSION_SIZE = 20;

// ============================================================================
// p_correct calculation (kept for compatibility)
// ============================================================================

export const NEW_ITEM_P_CORRECT = 0.35;
export const DECAY_LAMBDA = 0.1; // Decay rate for exponential weighting (per hour)

// p_correct thresholds
export const EASY_THRESHOLD = 0.8;     // p > 80% is easy
export const HARD_THRESHOLD_1 = 0.5;   // p < 50% is hard (first choice)
export const HARD_THRESHOLD_2 = 0.7;   // p < 70% is hard (fallback)

// ============================================================================
// Retry settings
// ============================================================================

export const RETRY_DELAY_PROBLEMS = 3; // Wait 3 other questions before retry
